import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useMediaQuery } from '@mui/material';
import { resultadoService } from '../../Services/Form';
import { IUserFromStorage } from '../../Interfaces/IUser';
import Loading from '../../Utils/Loading';
import VideoPlayer from '../../Components/VideoPlayer/VideoPlayer';

import DisplayAlimentacion from '../../Shared/Images/displayAlimentacion.jpg';

import '../../Shared/css/PlanAlimentacion/planAlimentacion.css'


const PlanAlimentacion = () => {

  const [mostrarVideo, setMostrarVideo] = useState<boolean>(false);
  const isMobile = useMediaQuery('(max-width: 650px)');
  const [linkPdf, setLinkPdf] = useState<string>();
  const [mes, setMes] = useState<number>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [varianteAlimentacion, setVarianteAlimentacion] = useState<number>();

  const user : IUserFromStorage = JSON.parse(localStorage.getItem("user")!);

  const navigate = useNavigate();

  useEffect(() => {
    resultadoService({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID
    })
      .then((res) => {
        setLinkPdf(res.data.data.linkPdfAlimentacion);
        setMes(res.data.data.mesAlimentacion);
        setVarianteAlimentacion(res.data.data.variacionAlimentacion);
      })
      .finally(() => {
        setIsLoading(false);
      })
  })

  return (
    <div className="pa-page">
      {isLoading ? (
        <div className="pa-loading">
          <Loading />
        </div>
      ) : (
        <>
          {/* Header */}
          <div className="pa-header" style={!isMobile ? { marginTop: '5vh'} : {}}>
            <button className="pa-back-btn" onClick={() => navigate('/producto/2')}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
            </button>
            <div>
              <span className="pa-header-label">Tu nutrición</span>
              <h1 className="pa-header-title">Plan de Alimentación</h1>
            </div>
          </div>

          <div className="pa-content">
            {/* Video Section */}
            <div className="pa-video-container">
              {!mostrarVideo ? (
                <div className="pa-video-thumbnail" onClick={() => setMostrarVideo(true)}>
                  <div className="pa-play-overlay">
                    <div className="pa-play-btn">
                      <svg width="22" height="22" viewBox="0 0 24 24" fill="#FFFFFF">
                        <path d="M8 5.14v14l11-7-11-7z"/>
                      </svg>
                    </div>
                    <span className="pa-play-text">Ver explicación</span>
                  </div>
                  <img src={DisplayAlimentacion} alt="Plan de Alimentación" className="pa-video-img" />
                </div>
              ) : (
                <div className="pa-video-player">
                  <VideoPlayer
                    url='https://player.vimeo.com/external/1005444184.m3u8?s=901cc19f0f7118fa900910d1314ac592c407d270&logging=false'
                    autoplay={true}
                  />
                </div>
              )}
            </div>

            {/* Info Card */}
            <div className="pa-info-card">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#E8A817" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/>
              </svg>
              <p>Mira el video explicativo para entender cómo seguir tu plan de alimentación correctamente. Luego descarga el PDF.</p>
            </div>

            {/* Download Button */}
            {mes && (
              <a
                className="pa-download-link"
                target="_blank"
                rel="noopener noreferrer"
                href={linkPdf}
              >
                <button className="pa-download-btn">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                  Descargar Plan · Mes {mes}
                </button>
              </a>
            )}

            {/* Variante Link */}
            {varianteAlimentacion === 0 && (
              <a
                className="pa-variante-link"
                target="_blank"
                rel="noopener noreferrer"
                href="https://wa.link/saxein"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/>
                  <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/>
                </svg>
                Adquiere tu nueva versión de alimentación
              </a>
            )}

            {/* Back Button */}
            <button className="pa-nav-btn" onClick={() => navigate('/producto/2')}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Volver
            </button>
          </div>
        </>
      )}
    </div>
  )
}

export default PlanAlimentacion;